let activeOrganizationScopeId: string | null = null;

export function setActiveOrganizationScopeId(
  organizationId: string | null,
): boolean {
  if (activeOrganizationScopeId === organizationId) return false;
  activeOrganizationScopeId = organizationId;
  return true;
}

export function getActiveOrganizationScopeId(): string | null {
  return activeOrganizationScopeId;
}

export function organizationScopedSessionStorageKey(
  baseKey: string,
  organizationId: string | null = activeOrganizationScopeId,
): string | null {
  if (!organizationId) return null;
  return `${baseKey}:organization:${organizationId}`;
}
